/**
 * AuditLogHeader displays the header of the audit log modal.
 */
import { UnlikelyMark } from "@targeted-support/ui/features/overview";
import { Download, X } from "lucide-react";

interface AuditLogHeaderProps {
  sessionId?: string;
  isComplete?: boolean;
  turnCount: number;
  onClose: () => void;
  onDownloadPDF?: () => void;
}

export const AuditLogHeader = ({
  sessionId,
  isComplete,
  turnCount,
  onClose,
  onDownloadPDF,
}: AuditLogHeaderProps) => (
  <div className="flex flex-none items-center gap-3 border-b border-brand-border px-6 py-3.5">
    <UnlikelyMark size={1} />
    <h2 className="text-[17px] font-semibold tracking-[-0.01em] text-brand-foreground">
      Audit log
    </h2>
    {sessionId && (
      <span className="rounded-full bg-brand-primary/[0.07] px-2.5 py-0.5 text-xs text-brand-muted">
        session {sessionId.slice(0, 6)}
      </span>
    )}
    {isComplete && (
      <span className="rounded-full bg-green-500/10 px-2.5 py-0.5 text-xs font-medium text-green-600">
        Complete
      </span>
    )}
    <span className="text-xs text-brand-muted">
      {turnCount} {turnCount === 1 ? "turn" : "turns"}
    </span>
    <span className="flex-1" />
    {onDownloadPDF && (
      <button
        type="button"
        onClick={onDownloadPDF}
        className="flex h-8 items-center gap-1.5 rounded-lg border border-brand-border px-3 text-[13px] font-medium text-brand-muted transition-colors hover:text-brand-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-unlikely/40"
      >
        <Download className="h-[15px] w-[15px]" aria-hidden={true} />
        Download PDF
      </button>
    )}
    <button
      type="button"
      onClick={onClose}
      aria-label="Close the audit log"
      className="flex h-8 w-8 items-center justify-center rounded-lg text-brand-muted transition-colors hover:bg-brand-primary/10 hover:text-brand-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-unlikely/40"
    >
      <X className="h-[17px] w-[17px]" aria-hidden={true} />
    </button>
  </div>
);
